module.exports = __webpack_public_path__ + "static/media/LT_F1.8424ec67.txt";